import { z } from "zod";
import {
  FreightCompanySchema,
  CompanyFreightSchema,
  createFreightCompanySchema,
  updateFreightCompanySchema,
  createCompanyFreightSchema,
  updateCompanyFreightSchema,
} from "@/lib/validations/business/freight";

/** Fields that can be edited in freight companies */
export type FreightCompanyEditableField = "company_name";

/** Interface defining permissions for freight company fields */
export interface FreightCompanyFieldPermissions {
  editable: FreightCompanyEditableField[];
  viewable: FreightCompanyEditableField[];
}

/** Fields that can be used for sorting freight companies */
export const FreightCompanySortable = [
  "company_name",
  "created",
  "updated",
] as const;
export type FreightCompanySortField = (typeof FreightCompanySortable)[number];

/** Complete freight company type with all fields */
export type FreightCompany = z.infer<typeof FreightCompanySchema>;

/** Type for creating new freight company */
export type CreateFreightCompanyInput = z.infer<
  typeof createFreightCompanySchema
>;

/** Type for updating existing freight company */
export type UpdateFreightCompanyInput = z.infer<
  typeof updateFreightCompanySchema
>;

/** Simple freight company type for dropdowns */
export interface SimpleFreightCompany {
  id: string;
  company_name: string;
}

/** Company freight type with all fields */
export type CompanyFreight = z.infer<typeof CompanyFreightSchema>;

/** Type for creating new company freight */
export type CreateCompanyFreightInput = z.infer<
  typeof createCompanyFreightSchema
>;

/** Type for updating existing company freight */
export type UpdateCompanyFreightInput = z.infer<
  typeof updateCompanyFreightSchema
>;

/** Company freight with related freight company data */
export interface CompanyFreightWithRelations extends CompanyFreight {
  freightCompany: SimpleFreightCompany;
}
